import React from "react";

const Java_Type_Casting = () => {
  return (
    <div>
      <h1>Java Type Casting</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Type Casting in Java.</p>
    </div>
  );
};

export default Java_Type_Casting;
